import { ITheme } from "../../utils/theme";

export const containerStyle = {
  overflow: "auto",
  background: (theme: ITheme) => theme.palette.common.white,
  paddingRight: 1,
  paddingLeft: 1,
}

export const disclaimerStyle = {
  display: "flex",
  color: (theme: ITheme) => theme.palette.blue[650],
  cursor: "pointer",
  "& p": {
    fontWeight: "bold",
  },
  mb: 2,
  mt: 1
}

export const disclaimerIconStyle = (theme: ITheme) => ({
  color: theme.palette.blue[650],
  mr: '3px',
})


export const disclaimerContainerStyle = {
  position: "relative",
  width: "100%",
  margin: "auto"
}

export const disclaimerContentStyle = {
  position: "absolute",
  zIndex: "999",
  top: "40px",
  width: "100%"
}

export const bulletinIconStyle = {
  width: '4px',
  position: 'relative',
  top: '7px',
  mr: 1.5
}

export const contentStyle = {
  mb: 1
}